
import Dashboard from "../../pages/Dashboard";
import Login from "../../pages/Login";
import SongCE from "../../pages/SongCE";
import SongList from "../../pages/SongList";
import UserList from "../../pages/UserList";
import RenderPage from "../RenderPage";

export const routes = [
   
    {
        path:"/",
        component:<Login/>,
        private:false,
        roles:[]
    },
    {
        path:"/dashboard",
        component:<RenderPage children ={<Dashboard/>} />,
        private:true,
        roles:[]
    },
    {
        path:"/users",
        component:<RenderPage children ={<UserList/>} />,
        private:true,
        roles:[]
    },
    {
        path:"/songs",
        component:<RenderPage children ={<SongList/>} />,
        private:true,
        roles:[]
    },
     {
        path:"/songs/:type",
        component:<RenderPage children ={<SongCE/>} />,
        private:true,
        roles:[]
    },
    
    
]